export default __webpack_public_path__ + "static/media/5.f3e84e4d.jpeg";